export * from './emergency-patient-tracker.service';
